import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {BwAvailabilityService} from '../../../services/bwAvailability.service';
import {BwAvailability} from '../../../models/bwAvailability';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {formatDate} from '@angular/common';
import {SelectItem} from 'primeng/api';
import {TechnicalPopService} from '../../../services/technical-pop.service';

@Component({
  selector: 'app-bw-availability',
  templateUrl: './bw-availability.component.html',
  styleUrls: ['./bw-availability.component.scss']
})
export class BwAvailabilityComponent implements OnInit {
  bwAvailabilities: BwAvailability[] = [];
  filteredBwAvailabilities: BwAvailability[] = [];
  tPopsHeader = 'Reception tPOP';
  cols = [
    {field: 'technicalPop', header: 'Technical pop', sortDisabled: false},
    {header: 'Product', sortDisabled: true},
    {header: 'Method', sortDisabled: true},
    {header: 'Options', sortDisabled: true},
    {header: 'tPops', sortDisabled: true},
    {field: 'publicDescription', header: 'Public description', sortDisabled: true},
  ];
  arbitrated: any;
  filterParams = {
    product: '',
    tPop: null,
    cPop: null,
    options: '',
    injection: true,
    reception: false
  };
  success = false;
  error = false;
  saveError = false;
  successMessage = '';
  possibleTPops = [];
  possibleTPopsOptions: SelectItem[] = [{label: 'ALL', value: null}];
  possibleCPops = [];
  possibleCPopsOptions: SelectItem[] = [{label: 'ALL', value: null}];

  constructor(
    private bwAvailabilityService: BwAvailabilityService,
    private authService: AuthenticationService,
    public technicalPopService: TechnicalPopService,
    private utilsService: UtilsService) {
  }

  ngOnInit() {
    this.utilsService.lockUi();
    if (this.authService.userCurrent.roles.includes('ROLE_MCKAY')) {
      this.cols.push(
        {header: 'Updated by', sortDisabled: true},
        {header: 'Updated at', sortDisabled: true},
      );
    }
    this.getBwAvailabilities();
  }

  private getBwAvailabilities() {
    this.bwAvailabilityService.getBwAvailabilities().subscribe({
      next: res => {
        this.bwAvailabilities = res;
        this.bwAvailabilities.forEach(availability => {
          availability.products.forEach(product => {
            product.associatedTPops.map(tPops => tPops.technical_id).forEach(pop => {
              if (!this.possibleTPops.includes(pop)) {
                this.possibleTPops.push(pop);
                this.possibleTPopsOptions.push({label: pop, value: pop});
              }
            });
            this.possibleTPopsOptions.sort(function (a, b) {
              if (!a.value) {
                return -1;
              }
              if (!b.value) {
                return 1;
              }
              return a.label.localeCompare(b.label);
            });
            product.associatedTPops.map(tPops => tPops.commercial_pop).forEach(pop => {
              if (pop.includes(',')) {
                const cpops = pop.split(',');
                cpops.forEach(cpop => {
                  cpop = cpop.trim();
                  if (this.possibleCPops.filter(popx => popx === cpop).length === 0 && cpop !== '') {
                    this.possibleCPops.push(cpop);
                    this.possibleCPopsOptions.push({label: cpop, value: cpop});
                  }
                });
              } else {
                if (this.possibleCPops.filter(popx => popx === pop).length === 0 && pop !== '') {
                  this.possibleCPops.push(pop);
                  this.possibleCPopsOptions.push({label: pop, value: pop});
                }
              }
            });
            this.possibleCPopsOptions.sort(function (a, b) {
              if (!a.label) {
                return -1;
              }
              return a.label.localeCompare(b.label);
            });
            product.newPublicDescription = product.publicDescription;
            if (product.updatedAt) {
              product.updatedAt = formatDate(product.updatedAt, 'yyyy-MM-dd HH:mm:ss', 'en-US', 'UTC') + ' (UTC)';
            }
            product.textAriaRows = 1;
          });
          availability.products.sort((selectItem1, selectItem2) => {
            if (selectItem1.productName.toLowerCase() < selectItem2.productName.toLowerCase()) {
              return -1;
            }
            if (selectItem1.productName.toLowerCase() > selectItem2.productName.toLowerCase()) {
              return 1;
            }
            return 0;
          });
        });
        this.filteredBwAvailabilities = this.bwAvailabilities;
        this.filterByMethod();
        this.utilsService.unlockUi();
      },
      error: () => {
        this.error = true;
        this.utilsService.unlockUi();
      }
    });
  }

  filter() {
    this.filteredBwAvailabilities = this.bwAvailabilities;
    if (this.filterParams.product !== '') {
      this.filterByProduct();
    }
    if (this.filterParams.options !== '') {
      this.filterByOptions();
    }
    if (this.filterParams.cPop && this.filterParams.cPop !== '') {
      this.filterByCPop();
    }
    if (this.filterParams.tPop && this.filterParams.tPop !== '') {
      this.filterByTPop();
    }
    if (this.filterParams.injection && !this.filterParams.reception || !this.filterParams.injection && this.filterParams.reception) {
      this.filterByMethod();
    } else {
      this.tPopsHeader = 'tPOPs';
    }
  }

  private filterByProduct() {
    const co = [];
    this.filteredBwAvailabilities.forEach(bwAvailability => {
      const bwAvailabilityFiltered = this.initFilterParams(bwAvailability);
      bwAvailabilityFiltered.products = bwAvailability.products.filter(product => product.productName.toLowerCase().indexOf(this.filterParams.product.toLowerCase()) !== -1);
      co.push(bwAvailabilityFiltered);
    });
    this.filteredBwAvailabilities = co;
  }

  private filterByMethod() {
    if (this.filterParams.injection && !this.filterParams.reception) {
      this.tPopsHeader = 'Reception tPOP';
    } else {
      this.tPopsHeader = 'Injection tPOP';
    }
    const co = [];
    this.filteredBwAvailabilities.forEach(bwAvailability => {
      const mdAvailabilityFiltered = this.initFilterParams(bwAvailability);
      if (this.filterParams.injection) {
        mdAvailabilityFiltered.products = bwAvailability.products.filter(product => product.method.includes('injection'));
      } else {
        mdAvailabilityFiltered.products = bwAvailability.products.filter(product => product.method.includes('reception'));
      }
      co.push(mdAvailabilityFiltered);
    });
    this.filteredBwAvailabilities = co;
  }

  private filterByCPop() {
    const co = this.filteredBwAvailabilities.filter(bwAvailability => bwAvailability.cPop.toLowerCase().indexOf(this.filterParams.cPop.toLowerCase()) !== -1);
    this.filteredBwAvailabilities.forEach(bwAvailability => {
      const bwAvailabilityFiltered = this.initFilterParams(bwAvailability);
      bwAvailabilityFiltered.products = bwAvailability.products.filter(product =>
        product.associatedTPops.map(tpops => tpops.commercial_pop).join(',').toLowerCase().indexOf(this.filterParams.cPop.toLowerCase()) !== -1
      );
      co.push(bwAvailabilityFiltered);
    });
    this.filteredBwAvailabilities = co;
  }

  private filterByTPop() {
    const co = this.filteredBwAvailabilities.filter(bwAvailability => bwAvailability.technicalPop.toLowerCase().indexOf(this.filterParams.tPop.toLowerCase()) !== -1);
    this.filteredBwAvailabilities.forEach(bwAvailability => {
      const bwAvailabilityFiltered = this.initFilterParams(bwAvailability);
      bwAvailabilityFiltered.products = bwAvailability.products.filter(product =>
        product.associatedTPops.map(tPops => tPops.technical_id).join(',').toLowerCase().indexOf(this.filterParams.tPop.toLowerCase()) !== -1
      );
      co.push(bwAvailabilityFiltered);
    });
    this.filteredBwAvailabilities = co;
  }

  private filterByOptions() {
    const co = [];
    this.filteredBwAvailabilities.forEach(bwAvailability => {
      const bwAvailabilityFiltered = this.initFilterParams(bwAvailability);
      bwAvailabilityFiltered.products = bwAvailability.products.filter(product => product.options.toLowerCase().indexOf(this.filterParams.options.toLowerCase()) !== -1);
      co.push(bwAvailabilityFiltered);
    });
    this.filteredBwAvailabilities = co;
  }

  private initFilterParams(bwAvailability: BwAvailability) {
    const bwAvailabilityFiltered = {
      technicalPop: '',
      cPop: '',
      marketDataId: '',
      products: [],
    };
    bwAvailabilityFiltered.technicalPop = bwAvailability.technicalPop;
    bwAvailabilityFiltered.cPop = bwAvailability.cPop;
    bwAvailabilityFiltered.marketDataId = bwAvailability.marketDataId;
    return bwAvailabilityFiltered;
  }

  changePublicDescription(product) {
    product.textAriaRows = 1;
    if (product.newPublicDescription === product.publicDescription) {
      return;
    }
    this.bwAvailabilityService.changePublicDescription(product.id, product.newPublicDescription).subscribe({
      next: () => {
        this.saveError = false;
        this.success = true;
        this.successMessage = 'Public description has been updated.';
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        product.publicDescription = product.newPublicDescription;
        product.updatedBy = this.authService.userAuthenticated.name;
        product.updatedAt = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss', 'en-US', 'UTC') + ' (UTC)';
      },
      error: () => {
        this.success = false;
        this.saveError = true;
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }
    });
  }
}
